import modal from '../components/modal'
import chart from '../components/chart'

export const components = [
  {
    id: 'modal',
    name: 'Modal',
    zhName: '弹窗',
    description: '能够显示模态对话框组件。',
    demoList: modal.demoList,
    api: modal.api,
  },
  {
    id: 'charts',
    name: 'Charts',
    zhName: '柱状图',
    description: '能够显示数据的柱状图组件。',
    demoList: chart.demoList,
    api: chart.api,
  },
]

export const findById = id =>
  components.find(item => item.id === id) || {
    name: 'NotFound',
    zhName: '不存在',
    description: '请添加新的组件描述',
    demoList: [],
    api: '',
  }
